export default {"src":"/_next/static/media/AI-property-Logo-footer.879aefc4.svg","height":101,"width":111,"blurWidth":0,"blurHeight":0};